import React from 'react';
import styled from 'styled-components';
import Link from './Link';

const FilterHeaderContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(178, 94, 72, 0.1);
  font-family: Open Sans, sans-serif;
  font-size: 0.9rem;
  line-height: 1.4;
  margin-left: 1rem;
  margin-right: 1rem;
  
  ${props => props.theme.breakpoints.down("xs")} {
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    font-size: 0.85rem;
    margin-left: 1rem;
    margin-right: 1rem;
  }
`;

const FilterLabel = styled.span`
  color: #666;
  margin-right: 0.75rem;
  font-weight: 500;
  
  ${props => props.theme.breakpoints.down("xs")} {
    margin-right: 0.5rem;
  }
`;

const YearLink = styled(Link)`
  color: #AD5843;
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 2px;
  text-decoration: none;
  transition: all 0.15s ease;
  font-weight: 500;
  
  &:hover {
    color: #9C4235;
    text-decoration: underline;
  }
`;

const PostCount = styled.span`
  color: #666;
  font-weight: 400;
`;

const Separator = styled.span`
  color: #ccc;
  margin: 0 0.75rem;
  font-weight: bold;
  
  ${props => props.theme.breakpoints.down("xs")} {
    margin: 0 0.5rem;
  }
`;

const YearFilterHeader = ({ posts }) => {
  // Process posts to get year counts
  const yearCounts = {};
  
  posts.forEach(post => {
    const year = new Date(post.frontmatter.date).getFullYear().toString();
    yearCounts[year] = (yearCounts[year] || 0) + 1;
  });
  
  const sortedYears = Object.keys(yearCounts).sort((a, b) => b - a);
  
  return (
    <FilterHeaderContainer>
      {sortedYears.map((year, index) => (
        <React.Fragment key={year}>
          {index > 0 && <Separator>•</Separator>}
          <YearLink to={`/${year}/`}>
            {year} <PostCount>({yearCounts[year]})</PostCount>
          </YearLink>
        </React.Fragment>
      ))}
    </FilterHeaderContainer>
  );
};

export default YearFilterHeader;
